import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../../../services/Spinner.service';
import {User} from '../../../models/user';
import { LocalStorage } from '../../../services/local-storage';
import { PopupReportComponent } from '../../../users/popup/popup-report.component';
import { BootstrapModalModule } from 'ng2-bootstrap-modal';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import {Observable} from 'rxjs/Observable';
import  * as moment from 'moment-timezone';
import  * as moment1 from 'moment';
@Component({
  selector: 'app-wall',
  templateUrl: './wall.component.html',
  //styleUrls: ['./wall.component.css'],
  providers : [SharedService, PopupReportComponent]

})
export class AdminWallComponent implements OnInit {
  token:string;
  segmentArray=[];
  zizcard= [];
  loader:boolean=false;
  pagedzizcard = [];
  page:number=1;
  pagesize:number=3;
  totalPages:number;
  expirein = [];
  user = new User();
  key : string;
  rerender:boolean;
  public selected: string = '';
  public bflag: boolean;
  noZizFlag : boolean = false;
  public rerenderpopuplisting: boolean;
  currentdate: number;
  objLoaderStatus: boolean = false;
userId : number;
showExpire : boolean;
name = "";
timezomeGuess;
  constructor(private localstorage : LocalStorage,private shareService :SharedService,private loaderService : LoaderService,private router : Router, private ref: ChangeDetectorRef,private route: ActivatedRoute, private dialogService:DialogService) { 
    this.bflag = true;
    this.user.objLoaderStatus = false;
    this.timezomeGuess = moment.tz.guess();
  }
    showReport(segmentId: number) {
        this.shareService.CallDatawithToken("user/campaign/action?feedId="+segmentId,null,this.token).subscribe((result) => {
           if(result.data) {
          if(result.data.flag) {
              let disposable = this.dialogService.addDialog(PopupReportComponent, {
                message:'',
                segmentid: segmentId,
                flag: 'true'
              })
          }
          else if(!result.data.flag) {
             let disposable = this.dialogService.addDialog(PopupReportComponent, {
                message:'',
                segmentid: segmentId,
                flag: 'false'
              })
          }
           }
      });
         
            
        }
       
 convertDaysHour2(campaignDuration: number, value: number) {
          console.log("campaignDuration"+campaignDuration)
          var dateFormat;
          var dateTime;
          var getDate = new Date(value);
          var now;
          dateFormat = getDate.toString()
          dateFormat = moment1.utc(getDate).format('YYYY-MM-DD');
          dateTime = moment1(dateFormat + ' ' + campaignDuration, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD HH:mm');
          now = new Date();
          now = moment1(now).format('YYYY-MM-DD HH:mm');
          console.log("dateTime"+dateTime)
          console.log("now"+now)
          let getExpiryDate= moment(dateTime,"YYYY-MM-DD HH:mm:ss").diff(moment(now,"YYYY-MM-DD HH:mm:ss"));
          let seconds = Math.floor(getExpiryDate / 1000);
            let minute = Math.floor(seconds / 60);
            seconds = seconds % 60;
            let  hour = Math.floor(minute / 60);
            minute = minute % 60;
            let day = Math.floor(hour / 24);
            hour = hour % 24;
            return {
            day: day,
            hour: hour,
            minute: minute,
            seconds: seconds
    };
      }

  ngOnInit() {
     this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
    var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 

      this.currentdate =  Date.now();

    this.route.params.subscribe(params => {
    this.userId = Number.parseInt(params['id']);
    this.name = params['name'];
});
this.localstorage.setStorage("country",'');
       this.token=this.localstorage.getStorage('token');

       var i=0;
         this.loaderService.displayLoader(true);
  this.shareService.CallDatawithToken("admin/activeCampaign/"+this.userId+"?currentPage="+this.page+"&currentSize="+this.pagesize+"&timeZone="+this.timezomeGuess, null, this.token).subscribe((result) => {
  console.log(result.data);
  if(result.data){
     this.loader=false;
//this.zizcard = result.data;
this.totalPages = result.pagination.totalPages;
  if(result.data.length>0) {
      this.noZizFlag = false;

          this.pagedzizcard=result.data;
         for(var i=0; i<result.data.length; i++){
         var getResult = this.calculateDiff(result.data[i].endAt,result.data[i].startAt);

if(result.data[i].endAt){
            var expire =  this.convertDaysHour2(result.data[i].campaignDuration[0].endTime, result.data[i].endAt); 
             let day = expire.day;
             let hour = expire.hour;
             let minute = expire.minute;
             let seconds = expire.seconds;
             this.expirein[i] =[day,hour,minute,seconds];
           }
          this.pagedzizcard[i].expiretime=this.expirein[i];
                            if(getResult >=0){
            this.pagedzizcard[i].showExpire = false;
          // this.pagedzizcard[i].expiretime=expire;
          }
            else{
   this.pagedzizcard[i].showExpire = true;
            }
          this.zizcard.push(this.pagedzizcard[i]);
      }
      console.log(result.data[0].segment)
                this.segmentArray.push(result.data[0].segment);
       
            }
            else{
                this.noZizFlag = true;
            }

   this.loaderService.displayLoader(false);
  
}
else{
  console.log("inside else");
  this.noZizFlag = true;
  //this.errorFlag = true;
  //this.errormessage = "No Active Advertisements for this advertiser";
     this.loaderService.displayLoader(false);

}

     });
        
  }
  
    calculateDiff(str1, str2) {
        var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        var firstDate = new Date(str1);
        var d = new Date();
        console.log(d);
        console.log(firstDate)
        var secondDate = new Date(str2);
                console.log(secondDate)
if(secondDate >d){
        var diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
}
else{
  if(firstDate>d){
          var diffDays = Math.round(Math.abs((firstDate.getTime() - d.getTime()) / (oneDay)));
  }
  else{
    var diffDays = -1;
  }
}
console.log(diffDays);
        return diffDays;
    }
    getExpiryTimeString(d, h, m, s) {
        return  d + "D " + h + "H " + m + "M " + s + "S";
    }

     convertDaysHour(startAt, days = null) {
        let startdate = this.formatDate(startAt);
        let current = this.formatDate(this.currentdate);
                      var currentdate = new Date();

        console.log(startdate);
                console.log(current);
        if (startdate == current && days == 1) {
            var currentdate = new Date();
            return this.getExpiryTimeString(0, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
        } else {
            days = (days == null ? 0 : days);
            if(startdate == current){
            return this.getExpiryTimeString(days-1, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
          }
          else{
   if(startdate>current){
             return this.getExpiryTimeString(days,0,0,0);
            }
            else{
       return this.getExpiryTimeString(days, 24 - currentdate.getHours(), (60 - currentdate.getMinutes()), (60 - currentdate.getSeconds()));
       
            }
                    }
            // this.campaign.expiretime=this.getExpiryTimeString(this.someRange,0,0,0);
        }
       
    
      }
 formatDate(date) {

        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }


  clickedinterest(segment, i) {
    this.bflag=false;
    this.selected = segment.id;
     this.ref.detectChanges();
   this.loaderService.displayLoader(true);
    this.shareService.CallDatawithToken('user/campaign/campaignFeedBySegment/'+this.selected,null,this.token).subscribe((result) => {
       if(result.data.length>0) {
         // this.zizcard=result.data;
         for(var i=0; i<result.data.length; i++){
             var getResult = this.calculateDiff(result.data[i].endAt,result.data[i].startAt);

if(result.data[i].endAt){
            var expire =  this.convertDaysHour2(result.data[i].campaignDuration[0].endTime, result.data[i].endAt); 
             let day = expire.day;
             let hour = expire.hour;
             let minute = expire.minute;
             let seconds = expire.seconds;
             this.expirein[i] =[day,hour,minute,seconds];
           }
          this.zizcard[i].expiretime=this.expirein[i];
                        if(getResult >=0){
            this.zizcard[i].showExpire = false;
//  this.zizcard[i].expiretime=expire;  
          }
            else{
   this.zizcard[i].showExpire = true;
            }
         
         }
        }else {
        this.zizcard=[];
      }
      this.loaderService.displayLoader(false);
    });
}


//scroll pagination
onScroll() {
    window.onscroll = () => {
         let status = "not reached";
         let windowHeight = "innerHeight" in window ? window.innerHeight
             : document.documentElement.offsetHeight;
         let body = document.body, html = document.documentElement;
         let docHeight = Math.max(body.scrollHeight,
             body.offsetHeight, html.clientHeight,
             html.scrollHeight, html.offsetHeight);
         let windowBottom = windowHeight + window.pageYOffset;
         if (windowBottom >= docHeight) {
           status = 'bottom reached';
           
           console.log(status);
           console.log(this.page);
           if(this.page <= this.totalPages){
              this.page++;
              this.getZizCard(this.page);
           }
           
         }
         
      };
  }
//Pagination scroll end
getZizCard(page) {
 var token = this.localstorage.getStorage("token");
  this.loader=true;

  this.shareService.CallDatawithToken("admin/activeCampaign/"+this.userId+"?currentPage="+page+"&currentSize="+this.pagesize+"&timeZone="+this.timezomeGuess,null,token).subscribe((result) => {
        this.loader=false;
        if(result.data.length>0) {
          this.pagedzizcard = result.data;
         for(var i=0; i<result.data.length; i++){
              var getResult = this.calculateDiff(result.data[i].endAt,result.data[i].startAt);

if(result.data[i].endAt){
            var expire =  this.convertDaysHour2(result.data[i].campaignDuration[0].endTime, result.data[i].endAt); 
             let day = expire.day;
             let hour = expire.hour;
             let minute = expire.minute;
             let seconds = expire.seconds;
             this.expirein[i] =[day,hour,minute,seconds];
           }
          this.pagedzizcard[i].expiretime=this.expirein[i];
                       if(getResult >=0){
            this.pagedzizcard[i].showExpire = false;
          // this.pagedzizcard[i].expiretime=expire;
  }
            else{
   this.pagedzizcard[i].showExpire = true;
            }
          this.zizcard.push(this.pagedzizcard[i]);
      }
       
            }
      // else {
      //   this.zizcard=[];
      // }
  
     });
}
  homeinterest() {
  this.bflag=true;
  this.selected ='';
  this.loaderService.displayLoader(true);
   this.shareService.CallDatawithToken("admin/activeCampaign/"+this.userId+"&timeZone="+this.timezomeGuess,null,this.token).subscribe((result) => {
       if(result.data.length>0) {
          this.zizcard=result.data;
         for(var i=0; i<result.data.length; i++){
             var getResult = this.calculateDiff(result.data[i].endAt,result.data[i].startAt);

if(result.data[i].endAt){
            var expire =  this.convertDaysHour2(result.data[i].campaignDuration[0].endTime, result.data[i].endAt); 
             let day = expire.day;
             let hour = expire.hour;
             let minute = expire.minute;
             let seconds = expire.seconds;
             this.expirein[i] =[day,hour,minute,seconds];
           }
          this.zizcard[i].expiretime=this.expirein[i];
                           if(getResult >=0){
            this.zizcard[i].showExpire = false;
          }
            else{
   this.zizcard[i].showExpire = true;
            } 

         }
        }
      else {
        this.zizcard=[];
      }
          this.loaderService.displayLoader(false);
     });
  }

 findDeals(latitude:string, longitutude: string) {
    window.open("https://www.google.com/maps?q="+latitude+","+longitutude, "_blank");
 }
}



// WEBPACK FOOTER //
// ./src/app/admin/layout/advertisers/wall.component.ts